export type Dimension2D = {
	width: number,
	height: number
}

export type Point2D = {
	x: number,
	y: number
}

export type BoxArea2D = {
	dimensions: Dimension2D,
	position: Point2D
}

function collision(p1x, p1y, r1, p2x, p2y, r2) {
	var a
	var x
	var y

	a = r1 + r2
	x = p1x - p2x
	y = p1y - p2y

	if (a > Math.sqrt((x * x) + (y * y))) {
		return true
	} else {
		return false
	}
}

export default class Collider2D {
	boxArea: BoxArea2D

	constructor(area: BoxArea2D) {
		//convert coordinates to top/left instead of center
		this.boxArea = area
	}

	getArea() {
		return this.boxArea
	}

	collides(collider: Collider2D) {
		const a = this.getArea()
		const b = collider.getArea()

		//this is for future box collider
		// if (rect1.position.x < rect2.position.x + rect2.dimensions.width &&
		// 	rect1.position.x + rect1.dimensions.width > rect2.position.x &&
		// 	rect1.position.y < rect2.position.y + rect2.dimensions.height &&
		// 	rect1.position.y + rect1.dimensions.height > rect2.position.y) {
		// 	 return true
		// }

		return collision(a.position.x, a.position.y, a.dimensions.width / 2, b.position.x, b.position.y, b.dimensions.width / 2)
	}
}